const parent = document.querySelectorAll(".facets-container");
let eventAttached = false;
function actionFilter() {
    if (!eventAttached) {
        if (parent.length != 0) {
            parent.forEach(element => {
                element.addEventListener("click", function (event) {
                    const target = event.target;
                    // Tillad højst én valgt Duftprofil ad gangen.
// Den valgte checkbox kan stadig fravælges, så nul valg er muligt.
if (
    target.matches(
        'input[type="checkbox"][name="filter.p.m.custom.scent_profile"]'
    ) &&
    target.checked
) {
    element
        .querySelectorAll(
            'input[type="checkbox"][name="filter.p.m.custom.scent_profile"]'
        )
        .forEach((checkbox) => {
            if (checkbox !== target) {
                checkbox.checked = false;
            }
        });
}
                    if (target.matches(".filter-title") || target.closest(".filter-title")) {
                        event.preventDefault();
                        const detail = target.closest("action-filter")?.querySelector(".filter-attribute.vertical-filter");
                        if (element.dataset.filterType === "vertical" || element.dataset.filterType === "canvas") {
                            if (target.matches(".filter-title")) {
                                slideAnime({
                                    target: detail,
                                    parent: target,
                                    animeType: "slideToggle",
                                });
                            }else{
                                slideAnime({
                                    target: detail,
                                    parent: target.closest(".filter-title"),
                                    animeType: "slideToggle",
                                });
                            }
                        } else {
                            document.body.addEventListener("click", function(evt){
                                const t = evt.target;
                                if (!t.closest(".facets-container")) {
                                    const filterTitles = element.querySelectorAll(".filter-title");
                                    filterTitles.forEach(function (filterTitle) {
                                        if (window.innerWidth > 1024) {
                                            filterTitle.classList.remove("opened");
                                        }
                                    });
                                }
                            });
                            if (target.matches(".filter-title")) {
                                if (detail) {
                                    slideAnime({
                                        target: detail,
                                        parent: target,
                                        animeType: "slideToggle",
                                    });
                                }else{
                                    if (target.classList.contains("opened")) {
                                        target.classList.remove("opened");
                                    } else {
                                        const filterTitles = element.querySelectorAll(".filter-title");
                                        filterTitles.forEach(function (filterTitle) {
                                        filterTitle.classList.remove("opened");
                                        });
                                        target.classList.add("opened");
                                        setTimeout(() => {
                                            target.closest("details")?.setAttribute("open", "");
                                        }, 100);
                                    }
                                }
                            }else{
                                if (detail) {
                                    slideAnime({
                                        target: detail,
                                        parent: target.closest(".filter-title"),
                                        animeType: "slideToggle",
                                    });
                                }else{
                                    if (target.closest(".filter-title").classList.contains("opened")) {
                                        target.closest(".filter-title").classList.remove("opened");
                                    } else {
                                        const filterTitles = element.querySelectorAll(".filter-title");
                                        filterTitles.forEach(function (filterTitle) {
                                            filterTitle.classList.remove("opened");
                                        });
                                        target.closest(".filter-title").classList.add("opened");
                                        setTimeout(() => {
                                            target.closest("details")?.setAttribute("open", "");
                                        }, 100);
                                    }
                                }
                            }
                            
                        }
                    }
                });
            });
        }
       
        eventAttached = true;
    }
}

actionFilter();

/*
 * Aromaterapi er et single-select-filter med mulighed for nul valg.
 *
 * Inputs forbliver checkboxes, så en aktiv værdi kan klikkes fra igen.
 * Capture-listeneren kører før temaets normale input-handler og sørger
 * for, at et nyt valg erstatter det tidligere på både desktop og mobil.
 */
const ESENSERA_AROMATHERAPY_FILTER_PARAM =
  "filter.p.m.custom.aromatherapy";

function normalizeEsenseraAromatherapyValue(
  value
) {
  return String(value || "")
    .normalize("NFC")
    .toLocaleLowerCase("da-DK")
    .trim()
    .replace(/\s+/g, " ");
}

function synchronizeEsenseraAromatherapySelection(
  sourceInput
) {
  const selectedValue =
    sourceInput.checked
      ? normalizeEsenseraAromatherapyValue(
          sourceInput.value
        )
      : "";

  document
    .querySelectorAll(
      `input[type="checkbox"][name="${ESENSERA_AROMATHERAPY_FILTER_PARAM}"]`
    )
    .forEach((input) => {
      input.checked = Boolean(
        selectedValue &&
        normalizeEsenseraAromatherapyValue(
          input.value
        ) === selectedValue
      );
    });
}

document.addEventListener(
  "input",
  function (event) {
    const input = event.target;

    if (
      !input?.matches?.(
        `input[type="checkbox"][name="${ESENSERA_AROMATHERAPY_FILTER_PARAM}"]`
      ) ||
      input.disabled
    ) {
      return;
    }

    synchronizeEsenseraAromatherapySelection(
      input
    );
  },
  true
);

/*
 * Gamle eller manuelt konstruerede URL'er kan indeholde flere
 * Aromaterapi-værdier. Normalisér dem én gang til den sidste værdi,
 * så produktgrid, chips og checkboxes altid starter i samme tilstand.
 */
function normalizeLegacyEsenseraAromatherapyUrl() {
  const url = new URL(window.location.href);
  const values = url.searchParams
    .getAll(
      ESENSERA_AROMATHERAPY_FILTER_PARAM
    )
    .map((value) => String(value || "").trim())
    .filter(Boolean);

  if (values.length <= 1) {
    return false;
  }

  url.searchParams.delete(
    ESENSERA_AROMATHERAPY_FILTER_PARAM
  );

  url.searchParams.set(
    ESENSERA_AROMATHERAPY_FILTER_PARAM,
    values[values.length - 1]
  );

  window.location.replace(url.toString());
  return true;
}

normalizeLegacyEsenseraAromatherapyUrl();

/*
 * På den samlede søgeside er Type et almindeligt,
 * lokalt single-select-filter. Lad browseren ændre
 * checkboxen normalt og sørg derefter for, at præcis
 * én Type er valgt i den aktuelle formular.
 */
document.addEventListener(
  "change",
  function (event) {
    const input = event.target;

    if (
      !document.querySelector(
        "[data-esensera-full-search-config]"
      ) ||
      !input.matches(
        ".js-type-collection-checkbox"
      )
    ) {
      return;
    }

    if (input.disabled) {
      return;
    }

    const form = input.closest("form");

    if (!form) {
      return;
    }

    const typeOptions = Array.from(
      form.querySelectorAll(
        ".js-type-option[data-type-handle]"
      )
    );

    const currentOption = input.closest(
      ".js-type-option[data-type-handle]"
    );

    if (!currentOption) {
      return;
    }

    if (input.checked) {
      typeOptions.forEach((option) => {
        const checkbox = option.querySelector(
          ".js-type-collection-checkbox"
        );

        if (checkbox && checkbox !== input) {
          checkbox.checked = false;
        }
      });
    } else {
      const hasCheckedType = typeOptions.some(
        (option) =>
          option.querySelector(
            ".js-type-collection-checkbox"
          )?.checked
      );

      if (!hasCheckedType) {
        const allOption = typeOptions.find(
          (option) =>
            option.dataset.typeHandle === "all"
        );

        const allCheckbox = allOption?.querySelector(
          ".js-type-collection-checkbox"
        );

        if (allCheckbox) {
          allCheckbox.checked = true;
        }
      }
    }

    typeOptions.forEach((option) => {
      const checkbox = option.querySelector(
        ".js-type-collection-checkbox"
      );

      const isActive = Boolean(
        checkbox?.checked
      );

      option.dataset.typeActive =
        isActive ? "true" : "false";

      if (isActive) {
        option.setAttribute(
          "aria-current",
          "page"
        );
      } else {
        option.removeAttribute(
          "aria-current"
        );
      }
    });
  },
  true
);

// Duftprofil styrer profil-collectionen.
// Type bevares som det underliggende produktfilter.
document.addEventListener(
  "change",
  function (event) {
    const input = event.target;

    /*
     * På den samlede søgeside skal Duftprofil filtrere
     * det allerede sammenflettede produktgrundlag lokalt.
     * Collection-navigationen nedenfor bruges kun uden
     * for den specialbyggede søgeside.
     */
    if (
      document.querySelector(
        "[data-esensera-full-search-config]"
      )
    ) {
      return;
    }

    if (
      !input.matches(
        'input[type="checkbox"][name="filter.p.m.custom.scent_profile"]'
      )
    ) {
      return;
    }

    if (input.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const profileHandle = input.value
      .trim()
      .toLowerCase();

    const profileHandles = [
      "citrus",
      "floral",
      "aromatic",
      "fresh",
      "spicy",
      "gourmand",
      "resinous",
      "woody"
    ];

    if (!profileHandles.includes(profileHandle)) return;

    const typeHandles = [
      "essential-oils",
      "absolutes",
      "co2-extracts",
      "isolates",
      "perfumery-bases",
      "blends",
      "resins",
      "all"
    ];

    const typeLabels = {
      "essential-oils": "Æterisk olie",
      "absolutes": "Absolut",
      "co2-extracts": "CO2-ekstrakt",
      "isolates": "Naturligt duftstof",
      "perfumery-bases": "Naturlig parfumebase",
      "blends": "Blend",
      "resins": "Resin og Røgelse"
    };

    const currentCollectionHandle =
      window.location.pathname
        .replace(/^\/collections\//, "")
        .split("/")[0] || "all";

    /*
     * Hvis profilen vælges fra en Type-collection,
     * huskes denne Type som basistypen.
     */
    if (typeHandles.includes(currentCollectionHandle)) {
      sessionStorage.setItem(
        "esenseraBaseTypeCollection",
        currentCollectionHandle
      );
    }

    const baseTypeHandle =
      sessionStorage.getItem(
        "esenseraBaseTypeCollection"
      ) || "all";

    const currentParams = new URLSearchParams(
      window.location.search
    );

    currentParams.delete("page");
    currentParams.delete("section_id");
    currentParams.delete(
      "filter.p.m.custom.scent_profile"
    );
    currentParams.delete("filter.p.product_type");
    currentParams.delete("filter.p.tag");

    let targetPath;

    if (input.checked) {
      /*
       * En profil bliver valgt:
       * gå til profilens collection.
       */
      targetPath = appendEsenseraOlfactiveTagsToPath(
        `/collections/${profileHandle}`
      );

      currentParams.set(
        "filter.p.m.custom.scent_profile",
        input.value
      );

      /*
       * Bevar den valgte Type som underliggende filter.
       */
      if (
        baseTypeHandle !== "all" &&
        typeLabels[baseTypeHandle]
      ) {
        currentParams.set(
          "filter.p.product_type",
          typeLabels[baseTypeHandle]
        );
      }
    } else {
      /*
       * Profilen klikkes fra:
       * gå tilbage til den huskede Type-collection.
       */
      targetPath = appendEsenseraOlfactiveTagsToPath(
        `/collections/${baseTypeHandle}`
      );
    }

    const targetUrl = new URL(
      targetPath,
      window.location.origin
    );

    currentParams.forEach((value, key) => {
      targetUrl.searchParams.append(key, value);
    });

    sessionStorage.setItem(
      "esenseraCollectionScrollPosition",
      String(window.scrollY)
    );

    

    window.location.assign(targetUrl.toString());
  },
  true
);


const ESENSERA_TYPE_LABELS = {
  "essential-oils": "Æterisk olie",
  "absolutes": "Absolut",
  "co2-extracts": "CO2-ekstrakt",
  "isolates": "Naturligt duftstof",
  "perfumery-bases": "Naturlig parfumebase",
  "blends": "Blend",
  "resins": "Resin og Røgelse"
};

const ESENSERA_TYPE_HANDLES = [
  ...Object.keys(ESENSERA_TYPE_LABELS),
  "all"
];

const ESENSERA_PROFILE_HANDLES = [
  "citrus",
  "floral",
  "aromatic",
  "fresh",
  "spicy",
  "gourmand",
  "resinous",
  "woody"
];

/*
 * På collection-sider bruger Olfactive character den klassiske
 * tagsti: /collections/<collection>/<tag-1>+<tag-2>.
 *
 * Shopify kombinerer værdier i samme storefront-filter med OR,
 * mens tagstien kombinerer tags med AND. Derfor ligger de valgte
 * Olfactive characters i stien og alle øvrige filtre i querystringen.
 */
function esenseraHandleizeTag(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/æ/g, "ae")
    .replace(/ø/g, "o")
    .replace(/å/g, "a")
    .replace(/Æ/g, "ae")
    .replace(/Ø/g, "o")
    .replace(/Å/g, "a")
    .toLocaleLowerCase("en-US")
    .trim()
    .replace(/&/g, "-and-")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function getEsenseraShopRoot() {
  const root =
    window.Shopify?.routes?.root || "/";

  return root.endsWith("/")
    ? root
    : `${root}/`;
}

function getEsenseraCollectionPathState(
  pathname = window.location.pathname
) {
  const root = getEsenseraShopRoot();
  const collectionPrefix =
    `${root}collections/`;

  const normalizedPathname =
    String(pathname || "");

  const prefixIndex =
    normalizedPathname.indexOf(
      collectionPrefix
    );

  if (prefixIndex === -1) {
    return null;
  }

  const remainder =
    normalizedPathname
      .slice(
        prefixIndex +
          collectionPrefix.length
      )
      .replace(/^\/+|\/+$/g, "");

  const segments = remainder
    .split("/")
    .filter(Boolean);

  const collectionHandle =
    decodeURIComponent(
      segments[0] || "all"
    );

  const tagHandles = segments[1]
    ? decodeURIComponent(segments[1])
        .split("+")
        .map((value) =>
          esenseraHandleizeTag(value)
        )
        .filter(Boolean)
    : [];

  return {
    root,
    collectionHandle,
    tagHandles: [
      ...new Set(tagHandles)
    ]
  };
}

function getEsenseraActiveOlfactiveHandles() {
  const pathState =
    getEsenseraCollectionPathState();

  if (!pathState) {
    return [];
  }

  const params = new URLSearchParams(
    window.location.search
  );

  const legacyHandles = params
    .getAll("filter.p.tag")
    .map((value) =>
      esenseraHandleizeTag(value)
    )
    .filter(Boolean);

  return [
    ...new Set([
      ...pathState.tagHandles,
      ...legacyHandles
    ])
  ];
}

function buildEsenseraCollectionOlfactiveUrl(
  tagHandles
) {
  const pathState =
    getEsenseraCollectionPathState();

  if (!pathState) {
    return null;
  }

  const normalizedHandles = [
    ...new Set(
      (tagHandles || [])
        .map((value) =>
          esenseraHandleizeTag(value)
        )
        .filter(Boolean)
    )
  ];

  const params = new URLSearchParams(
    window.location.search
  );

  params.delete("filter.p.tag");
  params.delete("page");
  params.delete("section_id");

  let pathname =
    `${pathState.root}collections/` +
    pathState.collectionHandle;

  if (normalizedHandles.length) {
    pathname +=
      `/${normalizedHandles.join("+")}`;
  }

  const url = new URL(
    pathname,
    window.location.origin
  );

  params.forEach((value, key) => {
    url.searchParams.append(key, value);
  });

  return url;
}

function appendEsenseraOlfactiveTagsToPath(
  pathname,
  tagHandles =
    getEsenseraActiveOlfactiveHandles()
) {
  const normalizedHandles = [
    ...new Set(
      (tagHandles || [])
        .map((value) =>
          esenseraHandleizeTag(value)
        )
        .filter(Boolean)
    )
  ];

  const cleanPathname =
    String(pathname || "")
      .replace(/\/+$/g, "");

  return normalizedHandles.length
    ? `${cleanPathname}/${normalizedHandles.join("+")}`
    : cleanPathname;
}

function applyEsenseraCollectionOlfactiveState(
  tagHandles,
  event = null
) {
  const targetUrl =
    buildEsenseraCollectionOlfactiveUrl(
      tagHandles
    );

  if (!targetUrl) {
    return false;
  }

  event?.preventDefault?.();
  event?.stopPropagation?.();
  event?.stopImmediatePropagation?.();

  const facetController =
    window.EsenseraFacetFiltersForm;

  if (
    facetController &&
    typeof facetController.renderPage ===
      "function"
  ) {
    facetController.renderPage(
      targetUrl.searchParams.toString(),
      event,
      true,
      targetUrl.pathname
    );

    return true;
  }

  window.location.assign(
    targetUrl.toString()
  );

  return true;
}

/*
 * Input-eventet fanges før temaets almindelige facetformular.
 * Dermed bliver filter.p.tag ikke sendt som en OR-baseret queryfacet.
 */
document.addEventListener(
  "input",
  function (event) {
    const input = event.target;

    if (
      document.querySelector(
        "[data-esensera-full-search-config]"
      ) ||
      !getEsenseraCollectionPathState() ||
      !input.matches(
        'input[type="checkbox"][name="filter.p.tag"]'
      ) ||
      input.disabled
    ) {
      return;
    }

    const candidateHandle =
      esenseraHandleizeTag(input.value);

    if (!candidateHandle) {
      return;
    }

    const activeHandles =
      getEsenseraActiveOlfactiveHandles();

    const nextHandles = input.checked
      ? [
          ...activeHandles,
          candidateHandle
        ]
      : activeHandles.filter(
          (handle) =>
            handle !== candidateHandle
        );

    applyEsenseraCollectionOlfactiveState(
      nextHandles,
      event
    );
  },
  true
);

/*
 * De aktive path-tags har egne chips, fordi current_tags ikke
 * optræder i collection.filters.active_values.
 */
document.addEventListener(
  "click",
  function (event) {
    const link = event.target.closest(
      ".js-remove-olfactive-path-filter"
    );

    if (!link) {
      return;
    }

    const handle =
      esenseraHandleizeTag(
        link.dataset.olfactiveHandle
      );

    const nextHandles =
      getEsenseraActiveOlfactiveHandles()
        .filter(
          (activeHandle) =>
            activeHandle !== handle
        );

    applyEsenseraCollectionOlfactiveState(
      nextHandles,
      event
    );
  },
  true
);

function migrateLegacyEsenseraOlfactiveQuery() {
  if (
    document.querySelector(
      "[data-esensera-full-search-config]"
    ) ||
    !getEsenseraCollectionPathState()
  ) {
    return;
  }

  const params = new URLSearchParams(
    window.location.search
  );

  if (!params.has("filter.p.tag")) {
    return;
  }

  const targetUrl =
    buildEsenseraCollectionOlfactiveUrl(
      getEsenseraActiveOlfactiveHandles()
    );

  if (
    targetUrl &&
    targetUrl.toString() !==
      window.location.href
  ) {
    window.location.replace(
      targetUrl.toString()
    );
  }
}

function normalizeSearchParamsString(
  searchParamsString = window.location.search.slice(1)
) {
  return typeof searchParamsString === "string"
    ? searchParamsString.replace(/^\?/, "")
    : "";
}

function getCurrentCollectionHandle() {
  return (
    window.location.pathname
      .replace(/^\/collections\//, "")
      .split("/")[0] || "all"
  );
}

/*
 * Type afgøres altid af den aktuelle URL:
 * 1. filter.p.product_type på en profil-collection.
 * 2. Collection-handle på en Type-collection.
 * 3. Ellers "all".
 *
 * sessionStorage bruges ikke som datakilde til ghosting.
 */
function resolveActiveTypeHandle(
  searchParamsString = window.location.search.slice(1)
) {
  const params = new URLSearchParams(
    normalizeSearchParamsString(searchParamsString)
  );

  const productTypeValue = (
    params.get("filter.p.product_type") || ""
  ).trim().toLocaleLowerCase("da-DK");

  if (productTypeValue) {
    const matchingType = Object.entries(
      ESENSERA_TYPE_LABELS
    ).find(([, label]) => {
      return (
        label.trim().toLocaleLowerCase("da-DK") ===
        productTypeValue
      );
    });

    if (matchingType) {
      return matchingType[0];
    }
  }

  const collectionHandle =
    getCurrentCollectionHandle();

  if (
    ESENSERA_TYPE_HANDLES.includes(
      collectionHandle
    )
  ) {
    return collectionHandle;
  }

  return "all";
}
/*
 * Identificér de fire særlige filtre uafhængigt
 * af den rækkefølge Shopify leverer dem i.
 */
function getEsenseraFacetRole(filterElement) {
  if (
    filterElement.querySelector(
      ".js-type-option[data-type-handle]"
    )
  ) {
    return "type";
  }

  if (
    filterElement.querySelector(
      'input[name="filter.p.m.custom.scent_profile"]'
    )
  ) {
    return "scent-profile";
  }

  if (
  filterElement.querySelector(
    'input[name="filter.p.m.custom.perfumery_note"]'
  )
) {
  return "note";
}

if (
  filterElement.querySelector(
    'input[name="filter.p.m.custom.aromatherapy"]'
  )
) {
  return "aromatherapy";
}

if (
  filterElement.querySelector(
    'input[name="filter.p.tag"]'
  )
) {
  return "olfactive-character";
}

  return "other";
}

/*
 * Sørg for samme visuelle og semantiske rækkefølge
 * på desktop, mobil, initial indlæsning og AJAX-renderinger.
 */
function enforceEsenseraFacetOrder() {
  const facetOrder = {
  type: 10,
  "scent-profile": 20,
  note: 30,
  aromatherapy: 40,
  "olfactive-character": 50,
  other: 60
};

  [
    "#FacetsWrapperDesktop",
    "#FacetsWrapperMobile"
  ].forEach((wrapperSelector) => {
    document
      .querySelectorAll(wrapperSelector)
      .forEach((wrapper) => {
        const filters = Array.from(
          wrapper.children
        ).filter((element) =>
          element.matches(
            "action-filter.js-filter"
          )
        );

        if (filters.length < 2) return;

        const originalPositions = new Map(
          filters.map((filter, index) => [
            filter,
            index
          ])
        );

        const sortedFilters = [
          ...filters
        ].sort((first, second) => {
          const firstOrder =
            facetOrder[
              getEsenseraFacetRole(first)
            ];

          const secondOrder =
            facetOrder[
              getEsenseraFacetRole(second)
            ];

          if (firstOrder !== secondOrder) {
            return firstOrder - secondOrder;
          }

          return (
            originalPositions.get(first) -
            originalPositions.get(second)
          );
        });

        /*
         * Placér alle filterblokke ved den første
         * eksisterende filterposition. Dermed bliver
         * eksempelvis mobiloverskrifter og knapper stående.
         */
        const marker =
          document.createComment(
            "esensera-facet-order"
          );

        wrapper.insertBefore(
          marker,
          filters[0]
        );

        sortedFilters.forEach((filter) => {
          wrapper.insertBefore(
            filter,
            marker
          );
        });

        marker.remove();
      });
  });
}
/*
 * Åbn eller luk en lodret filtergruppe.
 *
 * Temaet beholder <details> åbent teknisk og styrer
 * det synlige indhold med display samt klassen "opened".
 */
function setEsenseraFacetOpenState(
  filterElement,
  shouldOpen
) {
  const details =
    filterElement.querySelector(
      "details"
    );

  const title =
    filterElement.querySelector(
      ".filter-title"
    );

  const content =
    filterElement.querySelector(
      ".filter-attribute.vertical-filter"
    );

  /*
   * Vandrette desktopfiltre fungerer som popovers
   * og skal ikke styres af denne funktion.
   */
  if (!details || !title || !content) {
    return;
  }

  /*
   * En typeblokeret gruppe skal altid være lukket,
   * uanset den almindelige standardtilstand.
   */
  if (
    filterElement.dataset
      .esenseraTypeBlocked === "true"
  ) {
    details.setAttribute("open", "");
    title.classList.add("opened");
    content.style.display = "none";

    return;
  }

  details.setAttribute("open", "");

  if (shouldOpen) {
    title.classList.remove("opened");
    content.style.display = "block";
  } else {
    title.classList.add("opened");
    content.style.display = "none";
  }
}


/*
 * Standardtilstand:
 *
 * Type, Duftprofil, Note og Aromaterapi er åbne.
 * Olfactive character er normalt lukket.
 *
 * Hvis filter.p.tag er aktivt, åbnes
 * Olfactive character automatisk.
 */
function applyEsenseraDefaultFacetOpenState(
  searchParamsString =
    window.location.search.slice(1)
) {
  const searchParams =
    new URLSearchParams(
      searchParamsString
    );

  const hasActiveOlfactiveCharacter =
    searchParams.has("filter.p.tag") ||
    getEsenseraActiveOlfactiveHandles()
      .length > 0 ||
    Boolean(
      document.querySelector(
        'input[name="filter.p.tag"]:checked'
      )
    );

  [
    "#FacetsWrapperDesktop",
    "#FacetsWrapperMobile"
  ].forEach((wrapperSelector) => {
    document
      .querySelectorAll(wrapperSelector)
      .forEach((wrapper) => {
        const filters =
          Array.from(
            wrapper.children
          ).filter((element) =>
            element.matches(
              "action-filter.js-filter"
            )
          );

        filters.forEach((filter) => {
          const role =
            getEsenseraFacetRole(
              filter
            );

          if (
            role === "type" ||
            role === "scent-profile" ||
            role === "note" ||
            role === "aromatherapy"
          ) {
            setEsenseraFacetOpenState(
              filter,
              true
            );

            return;
          }

          if (
            role ===
            "olfactive-character"
          ) {
            setEsenseraFacetOpenState(
              filter,
              hasActiveOlfactiveCharacter
            );
          }
        });
      });
  });
}

/*
 * Aktivér eller fjern en Type-bestemt blokering.
 *
 * Den tidligere disabled-tilstand gemmes, så en
 * Shopify-ghostet mulighed ikke fejlagtigt bliver
 * aktiveret, hvis blokeringen senere fjernes.
 */
function setEsenseraFacetTypeBlock(
  paramName,
  shouldBlock
) {
  const matchingFilters = Array.from(
    document.querySelectorAll(
      ".js-filter"
    )
  ).filter((filter) =>
    filter.querySelector(
      `input[name="${paramName}"]`
    )
  );

  matchingFilters.forEach((filter) => {
    const wasBlocked =
      filter.dataset
        .esenseraTypeBlocked === "true";

    const details =
      filter.querySelector("details");

    const title =
      filter.querySelector(
        ".filter-title"
      );

    const content =
      filter.querySelector(
        ".filter-attribute"
      );

    const inputs = Array.from(
      filter.querySelectorAll(
        `input[name="${paramName}"]`
      )
    );

    if (shouldBlock) {
      if (!wasBlocked) {
        filter.dataset.esenseraWasOpen =
          details?.hasAttribute("open")
            ? "true"
            : "false";

        filter.dataset
          .esenseraPreviousDisplay =
          content?.style.display || "";

        filter.dataset
          .esenseraTitleWasOpened =
          title?.classList.contains(
            "opened"
          )
            ? "true"
            : "false";

        inputs.forEach((input) => {
          input.dataset
            .esenseraDisabledBeforeTypeBlock =
            input.disabled
              ? "true"
              : "false";
        });
      }

      filter.dataset
        .esenseraTypeBlocked = "true";

      /*
 * Behold <details> åbent teknisk set.
 * Brana-temaet lukker selve filterindholdet
 * ved hjælp af display:none og slideAnime.
 *
 * Hvis open-attributten fjernes, kan indholdet
 * ikke vises korrekt igen.
 */
details?.setAttribute("open", "");
title?.classList.add("opened");

if (content) {
  content.style.display = "none";
}

      inputs.forEach((input) => {
        input.disabled = true;
      });

      return;
    }

    if (!wasBlocked) return;

    inputs.forEach((input) => {
      input.disabled =
        input.dataset
          .esenseraDisabledBeforeTypeBlock ===
        "true";

      delete input.dataset
        .esenseraDisabledBeforeTypeBlock;
    });

    if (
      filter.dataset.esenseraWasOpen ===
      "true"
    ) {
      details?.setAttribute("open", "");
    } else {
      details?.removeAttribute("open");
    }

    if (content) {
      content.style.display =
        filter.dataset
          .esenseraPreviousDisplay || "";
    }

    if (
      filter.dataset
        .esenseraTitleWasOpened === "true"
    ) {
      title?.classList.add("opened");
    } else {
      title?.classList.remove("opened");
    }

    delete filter.dataset
      .esenseraTypeBlocked;

    delete filter.dataset
      .esenseraWasOpen;

    delete filter.dataset
      .esenseraPreviousDisplay;

    delete filter.dataset
      .esenseraTitleWasOpened;
  });
}

/*
 * Typebestemte filterregler:
 *
 * Naturlig parfumebase:
 * - Duftprofil lukkes og blokeres.
 * - Aromaterapi lukkes og blokeres.
 *
 * Blend:
 * - Duftprofil lukkes og blokeres.
 * - Note lukkes og blokeres.
 */
function applyEsenseraTypeSpecificFacetState(
  searchParamsString =
    window.location.search.slice(1)
) {
  const activeTypeHandle =
    resolveActiveTypeHandle(
      searchParamsString
    );

  const blockAromaticProfile =
    activeTypeHandle ===
      "perfumery-bases" ||
    activeTypeHandle ===
      "blends";

  const blockNote =
    activeTypeHandle ===
      "blends";

  const blockAromatherapy =
    activeTypeHandle ===
      "perfumery-bases";

  setEsenseraFacetTypeBlock(
    "filter.p.m.custom.scent_profile",
    blockAromaticProfile
  );

  setEsenseraFacetTypeBlock(
    "filter.p.m.custom.perfumery_note",
    blockNote
  );

  setEsenseraFacetTypeBlock(
    "filter.p.m.custom.aromatherapy",
    blockAromatherapy
  );

  return {
    activeTypeHandle,
    blockAromaticProfile,
    blockNote,
    blockAromatherapy
  };
}

window.enforceEsenseraFacetOrder =
  enforceEsenseraFacetOrder;

window.applyEsenseraTypeSpecificFacetState =
  applyEsenseraTypeSpecificFacetState;

window.applyEsenseraDefaultFacetOpenState =
  applyEsenseraDefaultFacetOpenState;
function restoreBaseTypeSelection(
  searchParamsString = window.location.search.slice(1)
) {
  const currentCollectionHandle =
    getCurrentCollectionHandle();

  if (
    !ESENSERA_PROFILE_HANDLES.includes(
      currentCollectionHandle
    )
  ) {
    return;
  }

  const baseTypeHandle =
    resolveActiveTypeHandle(searchParamsString);

  /*
   * Hold kun sessionStorage synkroniseret til navigation,
   * men brug ikke værdien som grundlag for ghosting.
   */
  sessionStorage.setItem(
    "esenseraBaseTypeCollection",
    baseTypeHandle
  );

  document
    .querySelectorAll(
      ".js-type-option[data-type-handle]"
    )
    .forEach((option) => {
      const checkbox = option.querySelector(
        ".js-type-collection-checkbox"
      );

      if (!checkbox) return;

      const isBaseType =
        option.dataset.typeHandle ===
        baseTypeHandle;

      checkbox.checked = isBaseType;
      option.dataset.typeActive =
        isBaseType ? "true" : "false";

      if (isBaseType) {
        option.setAttribute(
          "aria-current",
          "page"
        );
      } else {
        option.removeAttribute(
          "aria-current"
        );
      }
    });
}

window.restoreBaseTypeSelection =
  restoreBaseTypeSelection;

// Fjern kun Type, men behold alle øvrige aktive filtre.
document.addEventListener(
  "click",
  function (event) {
    const removeTypeLink = event.target.closest(
      ".js-remove-type-filter"
    );

    if (!removeTypeLink) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const profileHandles = [
      "citrus",
      "floral",
      "aromatic",
      "fresh",
      "spicy",
      "gourmand",
      "resinous",
      "woody"
    ];

    const currentCollectionHandle =
      window.location.pathname
        .replace(/^\/collections\//, "")
        .split("/")[0] || "all";

    const currentParams = new URLSearchParams(
      window.location.search
    );

    currentParams.delete("filter.p.product_type");
    currentParams.delete("filter.p.tag");
    currentParams.delete("page");
    currentParams.delete("section_id");

    /*
     * På en profil-collection bliver vi på profilen.
     * "Alle produkter" betyder her: alle Types inden for profilen.
     *
     * På en almindelig Type-collection går vi til /collections/all.
     */
    const targetPath =
      appendEsenseraOlfactiveTagsToPath(
        profileHandles.includes(
          currentCollectionHandle
        )
          ? `/collections/${currentCollectionHandle}`
          : "/collections/all"
      );

    const targetUrl = new URL(
      targetPath,
      window.location.origin
    );

    currentParams.forEach((value, key) => {
      targetUrl.searchParams.append(key, value);
    });

    sessionStorage.setItem(
      "esenseraBaseTypeCollection",
      "all"
    );

    sessionStorage.setItem(
      "esenseraCollectionScrollPosition",
      String(window.scrollY)
    );

    

    window.location.assign(targetUrl.toString());
  },
  true
);
// Fjern kun Duftprofil og gå tilbage til den valgte Type.
document.addEventListener(
  "click",
  function (event) {
    const removeProfileLink = event.target.closest(
      ".js-remove-scent-profile"
    );

    if (!removeProfileLink) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const validTypeHandles = [
      "essential-oils",
      "absolutes",
      "co2-extracts",
      "isolates",
      "perfumery-bases",
      "blends",
      "resins",
      "all"
    ];

    let baseTypeHandle =
      sessionStorage.getItem(
        "esenseraBaseTypeCollection"
      ) || "all";

    if (!validTypeHandles.includes(baseTypeHandle)) {
      baseTypeHandle = "all";
    }

    const targetUrl = new URL(
      appendEsenseraOlfactiveTagsToPath(
        `/collections/${baseTypeHandle}`
      ),
      window.location.origin
    );

    const currentParams = new URLSearchParams(
      window.location.search
    );

    // Fjern kun Duftprofil.
    currentParams.delete(
      "filter.p.m.custom.scent_profile"
    );

    /*
     * Type er nu repræsenteret af collection-stien,
     * eksempelvis /collections/absolutes.
     */
    currentParams.delete("filter.p.product_type");
    currentParams.delete("filter.p.tag");

    currentParams.delete("page");
    currentParams.delete("section_id");

    // Bevar Note, Olfactive character, pris og sortering.
    currentParams.forEach((value, key) => {
      targetUrl.searchParams.append(key, value);
    });

    sessionStorage.setItem(
      "esenseraCollectionScrollPosition",
      String(window.scrollY)
    );

    // Profil-chippen ligger uden for mobilskuffen.
    sessionStorage.removeItem(
      "esenseraReopenMobileFilters"
    );

    window.location.assign(targetUrl.toString());
  },
  true
);
// Fjern Type og alle øvrige filtre.
document.addEventListener(
  "click",
  function (event) {
    const clearAllLink = event.target.closest(
      ".js-clear-all-collections"
    );

    if (!clearAllLink) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    sessionStorage.setItem(
      "esenseraBaseTypeCollection",
      "all"
    );

    sessionStorage.setItem(
      "esenseraCollectionScrollPosition",
      String(window.scrollY)
    );

    

    window.location.assign("/collections/all");
  },
  true
);

// Skift Type.
// Normal Type-navigation bruger den eksisterende data-type-url.
// På en profil-collection bliver profilen stående som collection.
document.addEventListener(
  "click",
  function (event) {
    const typeOption = event.target.closest(
      ".js-type-option[data-type-handle]"
    );

    if (!typeOption) return;

    /*
     * På den samlede søgeside er Type renderet som labels
     * med almindelige checkbox-inputs. Her skal klik derfor
     * ikke annulleres eller omdannes til collection-navigation.
     */
    if (
      document.querySelector(
        "[data-esensera-full-search-config]"
      )
    ) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const typeHandle = typeOption.dataset.typeHandle;
    if (!typeHandle) return;

    const profileHandles = [
      "citrus",
      "floral",
      "aromatic",
      "fresh",
      "spicy",
      "gourmand",
      "resinous",
      "woody"
    ];

    const typeLabels = {
      "essential-oils": "Æterisk olie",
      "absolutes": "Absolut",
      "co2-extracts": "CO2-ekstrakt",
      "isolates": "Naturligt duftstof",
      "perfumery-bases": "Naturlig parfumebase",
      "blends": "Blend",
      "resins": "Resin og Røgelse"
    };

    const currentCollectionHandle =
      window.location.pathname
        .replace(/^\/collections\//, "")
        .split("/")[0] || "all";

    const isProfileCollection =
      profileHandles.includes(currentCollectionHandle);

    const currentParams = new URLSearchParams(
      window.location.search
    );

    currentParams.delete("page");
    currentParams.delete("section_id");
    currentParams.delete("filter.p.tag");

    let targetUrl;
    let nextTypeHandle;

    if (!isProfileCollection) {
      /*
       * Uden en aktiv profil bruger vi den URL, som allerede
       * kommer fra Liquid. Den håndterer også klik på den
       * valgte Type, som sender tilbage til Alle produkter.
       */
      const typeUrl =
        typeOption.dataset.typeUrl ||
        typeOption.getAttribute("href");

      if (!typeUrl) return;

      const rawTypeUrl = new URL(
        typeUrl,
        window.location.origin
      );

      const isAllTypeTarget =
        rawTypeUrl.pathname
          .replace(/\/+$/g, "")
          .endsWith("/collections/all");

      targetUrl = new URL(
        appendEsenseraOlfactiveTagsToPath(
          rawTypeUrl.pathname
        ),
        window.location.origin
      );

      nextTypeHandle =
        isAllTypeTarget
          ? "all"
          : typeHandle;

      currentParams.delete("filter.p.product_type");
    } else {
      /*
       * På fx /collections/floral bliver vi på Floral.
       * Type skifter kun som et underliggende produktfilter.
       */
      const rememberedType =
        sessionStorage.getItem(
          "esenseraBaseTypeCollection"
        ) || "all";

      const isSelected =
        rememberedType === typeHandle;

      nextTypeHandle =
        typeHandle === "all"
          ? "all"
          : isSelected
            ? "all"
            : typeHandle;

      currentParams.delete("filter.p.product_type");

      if (
        nextTypeHandle !== "all" &&
        typeLabels[nextTypeHandle]
      ) {
        currentParams.set(
          "filter.p.product_type",
          typeLabels[nextTypeHandle]
        );
      }

      targetUrl = new URL(
        appendEsenseraOlfactiveTagsToPath(
          `/collections/${currentCollectionHandle}`
        ),
        window.location.origin
      );
    }

    targetUrl.search = "";

    currentParams.forEach((value, key) => {
      targetUrl.searchParams.append(key, value);
    });

    sessionStorage.setItem(
      "esenseraBaseTypeCollection",
      nextTypeHandle
    );

    sessionStorage.setItem(
      "esenseraCollectionScrollPosition",
      String(window.scrollY)
    );

    

    window.location.assign(targetUrl.toString());
  },
  true
);

// Gendan kun scrollposition efter collection-skift.
window.addEventListener("DOMContentLoaded", function () {
  window.restoreBaseTypeSelection?.();

  const savedScrollPosition = sessionStorage.getItem(
    "esenseraCollectionScrollPosition"
  );

  if (savedScrollPosition !== null) {
    sessionStorage.removeItem(
      "esenseraCollectionScrollPosition"
    );

    requestAnimationFrame(function () {
      window.scrollTo({
        top: Number(savedScrollPosition),
        left: 0,
        behavior: "auto"
      });
    });
  }

  /*
   * Ryd et eventuelt gammelt flag fra tidligere kode.
   * Filterskuffen skal ikke længere genåbnes automatisk.
   */
  sessionStorage.removeItem(
    "esenseraReopenMobileFilters"
  );
});
let typeAvailabilityRunId = 0;

async function updateTypeAvailability(
  searchParamsString = window.location.search.slice(1)
) {
  /*
   * Den samlede søgeside beregner Type-tilgængelighed
   * direkte ud fra det deduplikerede produktgrundlag.
   */
  if (
    document.querySelector(
      "[data-esensera-full-search-config]"
    )
  ) {
    return;
  }

  const runId = ++typeAvailabilityRunId;

  const normalizedSearchParams =
    normalizeSearchParamsString(
      searchParamsString
    );

  const activeTypeHandle =
    resolveActiveTypeHandle(
      normalizedSearchParams
    );

  const availabilityParams =
    new URLSearchParams(
      normalizedSearchParams
    );

  availabilityParams.delete("page");
  availabilityParams.delete("section_id");
  availabilityParams.delete(
    "filter.p.product_type"
  );

  const typeHandles = [
    ...new Set(
      Array.from(
        document.querySelectorAll(
          ".js-type-option[data-type-handle]"
        )
      )
        .map(
          (option) =>
            option.dataset.typeHandle
        )
        .filter(
          (handle) =>
            ESENSERA_TYPE_HANDLES.includes(
              handle
            )
        )
    )
  ];

  if (!typeHandles.length) return;

  async function fetchTypeCount(
    typeHandle
  ) {
    /*
     * De aktive Olfactive character-tags ligger i collection-stien.
     * Brug den samme tagsti i count-requestet, så Type indsnævres
     * baglæns af det aktuelle Olfactive character-valg.
     */
    const activeOlfactiveHandles =
      getEsenseraActiveOlfactiveHandles();

    const countPath =
      appendEsenseraOlfactiveTagsToPath(
        `${getEsenseraShopRoot()}collections/all`,
        activeOlfactiveHandles
      );

    const countUrl = new URL(
      countPath,
      window.location.origin
    );

    availabilityParams.forEach(
      (value, key) => {
        countUrl.searchParams.append(
          key,
          value
        );
      }
    );

    if (
      typeHandle !== "all" &&
      ESENSERA_TYPE_LABELS[typeHandle]
    ) {
      countUrl.searchParams.set(
        "filter.p.product_type",
        ESENSERA_TYPE_LABELS[
          typeHandle
        ]
      );
    }

    const response = await fetch(
      countUrl.toString(),
      {
        headers: {
          "X-Requested-With":
            "XMLHttpRequest"
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `HTTP ${response.status}`
      );
    }

    const htmlText =
      await response.text();

    const parsedHTML =
      new DOMParser().parseFromString(
        htmlText,
        "text/html"
      );

    if (
      parsedHTML.querySelector(
        "#ProductContainer .collection--empty"
      )
    ) {
      return {
        typeHandle,
        productCount: 0
      };
    }

    const countElement =
      parsedHTML.querySelector(
        "#ProductCountDesktop"
      );

    let productCount = 0;

    if (countElement) {
      const countText =
        countElement.textContent.trim();

      const countMatch =
        countText.match(/\d[\d.,]*/);

      if (countMatch) {
        productCount =
          Number(
            countMatch[0].replace(
              /[.,](?=\d{3}\b)/g,
              ""
            )
          ) || 0;
      }
    }

    return {
      typeHandle,
      productCount
    };
  }

  const results = await Promise.all(
    typeHandles.map(
      async (typeHandle) => {
        try {
          return await fetchTypeCount(
            typeHandle
          );
        } catch (error) {
          console.warn(
            `Kunne ikke opdatere Type "${typeHandle}":`,
            error
          );

          return null;
        }
      }
    )
  );

  if (runId !== typeAvailabilityRunId) {
    return;
  }

  const latestTypeOptions =
    Array.from(
      document.querySelectorAll(
        ".js-type-option[data-type-handle]"
      )
    );

  results
    .filter(Boolean)
    .forEach(
      ({
        typeHandle,
        productCount
      }) => {
        latestTypeOptions
          .filter(
            (option) =>
              option.dataset.typeHandle ===
              typeHandle
          )
          .forEach((option) => {
            const checkbox =
              option.querySelector(
                ".js-type-collection-checkbox"
              );

            const isActive =
              typeHandle ===
              activeTypeHandle;

            const shouldDisable =
              productCount === 0 &&
              !isActive &&
              typeHandle !== "all";

            option.style.opacity =
              shouldDisable
                ? "0.35"
                : "";

            option.style.pointerEvents =
              shouldDisable
                ? "none"
                : "";

            if (shouldDisable) {
              option.setAttribute(
                "aria-disabled",
                "true"
              );
            } else {
              option.removeAttribute(
                "aria-disabled"
              );
            }

            if (checkbox) {
              checkbox.disabled =
                shouldDisable;
            }
          });
      }
    );
}
let aromaticAvailabilityRunId = 0;
async function updateAromaticProfileAvailability(
  searchParamsString = window.location.search.slice(1)
) {
  /*
   * Den samlede søgeside beregner Duftprofil-tilgængelighed
   * direkte ud fra det deduplikerede produktgrundlag.
   */
  if (
    document.querySelector(
      "[data-esensera-full-search-config]"
    )
  ) {
    return;
  }

  const runId =
    ++aromaticAvailabilityRunId;

  const normalizedSearchParams =
    normalizeSearchParamsString(
      searchParamsString
    );

  const typeSpecificState =
  applyEsenseraTypeSpecificFacetState(
    normalizedSearchParams
  );

const activeTypeHandle =
  typeSpecificState.activeTypeHandle;

/*
 * Parfumebase og Blend skal ikke have en
 * aktiv Duftprofil-vælger.
 *
 * Stop også de otte unødvendige count-requests.
 */
if (
  typeSpecificState
    .blockAromaticProfile
) {
  return;
}

  const profileInputs = Array.from(
    document.querySelectorAll(
      'input[type="checkbox"][name="filter.p.m.custom.scent_profile"]'
    )
  );

  if (!profileInputs.length) return;

  const profileLabels = {
    citrus: "Citrus",
    floral: "Floral",
    aromatic: "Aromatic",
    fresh: "Fresh",
    gourmand: "Gourmand",
    spicy: "Spicy",
    resinous: "Resinous",
    woody: "Woody"
  };

  const currentParams =
    new URLSearchParams(
      normalizedSearchParams
    );

  currentParams.delete("page");
  currentParams.delete("section_id");
  currentParams.delete(
    "filter.p.m.custom.scent_profile"
  );

  /*
   * Brug samme Product Type-filter som produktgriddet.
   * Det gør beregningen uafhængig af, om en manuel
   * Type-collection indeholder præcis de samme produkter.
   */
  currentParams.delete(
    "filter.p.product_type"
  );

  if (
    activeTypeHandle !== "all" &&
    ESENSERA_TYPE_LABELS[
      activeTypeHandle
    ]
  ) {
    currentParams.set(
      "filter.p.product_type",
      ESENSERA_TYPE_LABELS[
        activeTypeHandle
      ]
    );
  }

  const uniqueProfileHandles = [
    ...new Set(
      profileInputs
        .map((input) =>
          input.value
            .trim()
            .toLowerCase()
        )
        .filter(
          (handle) =>
            profileLabels[handle]
        )
    )
  ];

  async function fetchProfileCount(
    profileHandle
  ) {
    /*
     * Duftprofil-counts skal beregnes inden for den samme
     * Olfactive character-tagsti som det viste produktgrid.
     */
    const activeOlfactiveHandles =
      getEsenseraActiveOlfactiveHandles();

    const countPath =
      appendEsenseraOlfactiveTagsToPath(
        `${getEsenseraShopRoot()}collections/all`,
        activeOlfactiveHandles
      );

    const countUrl = new URL(
      countPath,
      window.location.origin
    );

    currentParams.forEach(
      (value, key) => {
        countUrl.searchParams.append(
          key,
          value
        );
      }
    );

    countUrl.searchParams.set(
      "filter.p.m.custom.scent_profile",
      profileLabels[profileHandle]
    );

    const response = await fetch(
      countUrl.toString(),
      {
        headers: {
          "X-Requested-With":
            "XMLHttpRequest"
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        `HTTP ${response.status}`
      );
    }

    const htmlText =
      await response.text();

    const parsedHTML =
      new DOMParser().parseFromString(
        htmlText,
        "text/html"
      );

    if (
      parsedHTML.querySelector(
        "#ProductContainer .collection--empty"
      )
    ) {
      return {
        profileHandle,
        productCount: 0
      };
    }

    const countElement =
      parsedHTML.querySelector(
        "#ProductCountDesktop"
      );

    let productCount = 0;

    if (countElement) {
      const countText =
        countElement.textContent.trim();

      const countMatch =
        countText.match(/\d[\d.,]*/);

      if (countMatch) {
        productCount =
          Number(
            countMatch[0].replace(
              /[.,](?=\d{3}\b)/g,
              ""
            )
          ) || 0;
      }
    }

    return {
      profileHandle,
      productCount
    };
  }

  const results = await Promise.all(
    uniqueProfileHandles.map(
      async (profileHandle) => {
        try {
          return await fetchProfileCount(
            profileHandle
          );
        } catch (error) {
          console.warn(
            `Kunne ikke hente antal for Duftprofil "${profileHandle}":`,
            error
          );

          return null;
        }
      }
    )
  );

  if (
    runId !==
    aromaticAvailabilityRunId
  ) {
    return;
  }

  const latestProfileInputs =
    Array.from(
      document.querySelectorAll(
        'input[type="checkbox"][name="filter.p.m.custom.scent_profile"]'
      )
    );

  results
    .filter(Boolean)
    .forEach(
      ({
        profileHandle,
        productCount
      }) => {
        latestProfileInputs
          .filter(
            (input) =>
              input.value
                .trim()
                .toLowerCase() ===
              profileHandle
          )
          .forEach((input) => {
            const label =
              input.closest(
                "label.facet-checkbox"
              );

            const countElement =
              label?.querySelector(
                ".count"
              );

            if (countElement) {
              countElement.textContent =
                String(productCount);
            }

            const shouldDisable =
              productCount === 0 &&
              input.checked === false;

            input.disabled =
              shouldDisable;

            if (label) {
              label.style.opacity =
                shouldDisable
                  ? "0.35"
                  : "";

              label.style.pointerEvents =
                shouldDisable
                  ? "none"
                  : "";

              label.style.cursor =
                shouldDisable
                  ? "default"
                  : "";
            }
          });
      }
    );
}

window.updateAromaticProfileAvailability =
  updateAromaticProfileAvailability;
window.updateTypeAvailability = updateTypeAvailability;

if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    function () {
      migrateLegacyEsenseraOlfactiveQuery();

      enforceEsenseraFacetOrder();

applyEsenseraTypeSpecificFacetState();

applyEsenseraDefaultFacetOpenState();

updateTypeAvailability();

updateAromaticProfileAvailability();
    }
  );
} else {
  migrateLegacyEsenseraOlfactiveQuery();

  enforceEsenseraFacetOrder();

applyEsenseraTypeSpecificFacetState();

applyEsenseraDefaultFacetOpenState();

updateTypeAvailability();

updateAromaticProfileAvailability();
}